/**
 * Track Upload Images
 * 
 * @Author: Focci
 * @Date: 2023-08-16 15:04:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-16 15:04:44
 */

import PropTypes from 'prop-types'
import UploadTrigger from '@comp/upload/UploadTrigger'
import Uploader from '@comp/upload/Uploader'
import useUpload from '@hook/useUpload'
import { fetchPost } from '@lib/fetch/client'
import { useEffect } from 'react'

export function uploadFile({ file, controller }) {
  const { url } = file
  const { signal } = controller
  const src = url.split(',')[1]
  
  return fetchPost('property-claim/upload', { src }, { signal })
}

export default function TrackUploadImages({
  value = [],
  multiple = true,
  needBase64 = true,
  onFinish,
  successCallback = ({ src: url }) => ({ url }),
  fetcher = uploadFile
}) {
  const { 
    files, compelete, handleStartUpload, uploadCallback, removeIndex 
  } = useUpload(
    fetcher, 
    successCallback, 
    { needBase64, value, multiple }
  )

  // 判断是否全部上传完成
  useEffect(() => { compelete && onFinish(files) }, [compelete, files, onFinish])
  
  return (
    <div className="flex flex-wrap gap-2">
      {files.map((file, i) => (
        <Uploader 
          key={file.name}
          data={file}
          uploadCallback={uploadCallback}
          onClose={() => removeIndex(i)}
        />
      ))}
      {files.length <= 9 && (
        <UploadTrigger
          inputProps={{ multiple }} 
          onChange={handleStartUpload} 
        />
      )}
    </div>
  )
}

TrackUploadImages.propTypes = {
  value: PropTypes.array,
  multiple: PropTypes.bool,
  needBase64: PropTypes.bool,
  onFinish: PropTypes.func,
  successCallback: PropTypes.func,
  fetcher: PropTypes.func,
}
